var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSavingZone)?_c('navigation-menu-item',{attrs:{"title":"חיסכון לטווח הארוך","target":"saving-zone","small":true},on:{"navigate":function($event){return _vm.$emit('navigate')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }